import React from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';

import {useStateHook} from 'front-onceforall-core/dist/utils/customHooks';

import {captureError} from '../../../utils/log';

import {getMandates} from './utils';
import MandatesListView from './MandatesListView';

function MandatesListContainer({isCollectionMandate}) {
  const organisationId = useSelector(globalState => globalState.organisation.organisationId);
  const [state, setState] = useStateHook({
    mandates: [],
    loading: true,
    broadcastMandateServiceAuthorized: false
  });

  React.useEffect(() => {
    getMandates(organisationId, isCollectionMandate)
      .then(({mandates, broadcastMandateServiceAuthorized}) => {
        setState({
          mandates,
          broadcastMandateServiceAuthorized
        });
      })
      .catch(error => {
        captureError('Error while fetching mandates', error);
      })
      .finally(() => {
        setState({loading: false});
      });
  }, []);

  return (
    <MandatesListView
      loading={state.loading}
      mandates={state.mandates}
      isCollectionMandate={isCollectionMandate}
      broadcastMandateServiceAuthorized={state.broadcastMandateServiceAuthorized}
    />
  );
}

MandatesListContainer.propTypes = {
  isCollectionMandate: PropTypes.bool.isRequired
};

export default MandatesListContainer;
